export default __webpack_public_path__ + "static/media/logo.15921650.png";